module.exports = __webpack_public_path__ + "src/assets/img/s-autostart_w.1d74ea9d.svg";